import { Button2 } from "@/ui2/atoms/Button";
import EmptyStateIcon from "@/assets/images/icons2/icon--empty-state.svg?component";
import { Heading2 } from "@/ui2/atoms/Heading";

type EmptyNotesStateProps = {
  clearAll: VoidFunction;
};

export function EmptyNotesState({ clearAll }: EmptyNotesStateProps) {
  return (
    <div className="tw:mx-auto tw:flex tw:flex-col tw:items-center tw:justify-center tw:gap-4 tw:py-28.5">
      <EmptyStateIcon />

      <Heading2 as="h3" className="tw:text-text-tertiary" size={2}>
        No notes match the selected filters
      </Heading2>

      <Button2 onPress={clearAll} variant="secondary">
        Clear Filters
      </Button2>
    </div>
  );
}
